export default "__VITE_ASSET__lhX99_2P__"